import { Fragment } from "react";
import Content from "./Content";
import Header from "./Header";

export default function Customers() {
  return (
    <Fragment>
      <Header />
      <Content />
    </Fragment>
  );
}
